import { BoardContainerProps } from '../types/board.types'
import { BoardActionTypes } from '../actions/board.action'
import * as ColumnAction from '../actions/column.actionTypes'
import * as CardAction from '../actions/card.actionTypes'
import * as FilterAction from '../actions/filter.actionTypes'
import * as SidePanelAction from '../actions/sidePanel.actionTypes'
import * as MenuAction from '../actions/menu.actionTypes'
import * as BorderAction from '../actions/boardHeader.actionTypes'
import BoardConst from '../utils/constants/board'
import moment from 'moment'
import { uniqueArrayObject } from '../../utils/function'
import { updateTimleineTask, removeTimelineTask } from '../utils/timeline'

const BoardReducers = (
  state: BoardContainerProps,
  action: BoardActionTypes
): BoardContainerProps => {
  const initState = state
  let colData: any
  let viewAiData: any
  let finalColumns: any
  let boardTimeline: any
  let itemData: any
  let sourceCol: any
  let destinationCol: any

  switch (action.type) {
    /** Column Actions */
    case ColumnAction.BOARD_ADD_COLUMN:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.concat(action.payload),
        },
      }
    case ColumnAction.BOARD_EDIT_COLUMN:
      let columns = state.boardDetails.columns.map((c) => {
        if (c.id == action.columnId) {
          c = Object.assign({}, c, action.payload)
        }
        return c
      })
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns,
        },
      }
    case ColumnAction.BOARD_DELETE_COLUMN:
      const boardColumns = state.boardDetails.columns.filter(
        (c) => c.id != action.columnId
      )
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: boardColumns,
        },
      }
    case ColumnAction.BOARD_REORDER_COLUMN:
      const isVisualBoard = state.boardDetails.board || null
      let returnState: any = {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: action.columns,
          viewAiPane:
            action.viewAiPane !== undefined
              ? action.viewAiPane
              : state.boardDetails.viewAiPane,
        },
      }
      if (isVisualBoard === null || isVisualBoard === undefined) {
        returnState.boardTimeline =
          action.boardTimeline !== null && action.boardTimeline !== undefined
            ? action.boardTimeline
            : state.boardTimeline
      }
      return returnState

    /** Card Actions */
    case CardAction.ADD_AI_CARD: {
      const { parent, id } = action.payload
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map((c: any) => {
            if (parent && parent > 0 && id.indexOf('newAi_') !== -1) {
              c.data = c.data.map((d: any) => {
                if (parent == d.id) {
                  const dCount =
                    Number(d.subCount.doneCount) +
                    (action.payload.state == '0' ? 1 : 0)
                  d = {
                    ...d,
                    subCount: {
                      totalCount: Number(d.subCount.totalCount) + 1,
                      doneCount: dCount,
                    },
                  }
                  viewAiData = d
                }
                return d
              })
            }
            if (c.id == action.columnId) {
              c.data = [action.payload, ...c.data]
            }
            return c
          }),
          viewAiPane:
            state.boardDetails.viewAiPane &&
            viewAiData &&
            state.boardDetails.viewAiPane.id == viewAiData.id
              ? viewAiData
              : state.boardDetails.viewAiPane,
        },
      }
    }

    case CardAction.COPY_AI_CARD: {
      const { data, currentAiId } = action.payload
      const currentColumnIndex = state.boardDetails.columns.findIndex((col) =>
        col.data.find((item) => item.id === currentAiId)
      )

      const newState = {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map(
            (column: any, index: number) => {
              if (index !== currentColumnIndex) {
                return column
              }

              return {
                ...column,
                data: [
                  ...state.boardDetails.columns[currentColumnIndex].data,
                  ...data,
                ],
              }
            }
          ),
        },
      }

      return newState
    }

    case CardAction.UPDATE_AI_CARD:
      let _ai = action.payload
      if (_ai.state == '1' && _ai.start_date && _ai.due_date) {
        boardTimeline = updateTimleineTask(state, _ai)
      }
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map((c: any) => {
            if (c.id == action.columnId) {
              c.data = c.data.map((d: any) => {
                if (d.id == action.id) {
                  d = Object.assign(d, action.payload)
                }
                return d
              })
            }
            return c
          }),
        },
        boardTimeline:
          boardTimeline && Object.keys(boardTimeline).length
            ? boardTimeline
            : state.boardTimeline,
      }
    case CardAction.AI_CARD_CLICK:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )

      viewAiData =
        typeof colData.data !== 'undefined'
          ? colData.data.find(
              (item: { id: any }) => item.id == action.payload.id
            )
          : null
      if (viewAiData) {
        viewAiData.columnId = action.columnId
      }
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
      }
    case CardAction.WS_BOARD_UPDATE_S3DATA:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          s3Data: action.payload,
        },
      }
    case CardAction.BOARD_FREETEXT_ADD:
      // colData = initState.boardDetails.columns.find((col) => col.id == action.payload.board_column);
      // itemData = colData.data.find((item: { id: any; }) => item.id == action.aiId);

      finalColumns = initState.boardDetails.columns.map((column) => {
        if (column.id == action.payload.board_column) {
          column.data.unshift(Object.assign({}, action.payload))
        }
        return column
      })
      // let newColumn:any = initState.boardDetails.columns;
      // if (Object.keys(action.payload).length) {
      //     colData.data.unshift(action.payload);
      //   }
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: finalColumns,
        },
      }
    case CardAction.BOARD_FREETEXT_UPDATE:
      let newUpdatedColumn: any = initState.boardDetails.columns.map(
        (item: any) => {
          if (item.id == action.payload.board_column) {
            item.data = item.data.filter(
              (data: any) => !data.id.includes('newFt_')
            )
            item.data.unshift(action.payload)
          }
          return item
        }
      )
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: newUpdatedColumn,
        },
      }
    case CardAction.BOARD_UPDATE_ITEM_IN_COLUMN:
      let newEditUpdatedColumn: any = initState.boardDetails.columns.map(
        (item: any) => {
          if (item.id == action.payload.id) {
            item = Object.assign({}, item, action.payload)
          }
          return item
        }
      )
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: newEditUpdatedColumn,
        },
      }
    case CardAction.BOARD_DELETE_ITEM_IN_COLUMN:
      let newColumn: any = initState.boardDetails.columns.map((item: any) => {
        if (item.id == action.payload.colId) {
          item.data = item.data.filter(
            (it: any) => !(it.id == action.payload.id)
          )
        }
        return item
      })
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: newColumn,
        },
      }
    case CardAction.UPDATE_BASED_ON_AI_POPUP:
      let elem: any = document.querySelector('#fromMainAIPopup')
      if (initState.boardDetails.viewAiPane && elem) {
        elem.value = '1'
      }
      let updatedSubAis: any = []
      let updatedSubAisData: any = []
      let parentAisData: any = []
      let mirrorTagIds: any = initState.boardDetails.mirrorTagIds
      let mirrorTagIdsExists: any =
        mirrorTagIds !== undefined &&
        Object.values(mirrorTagIds).indexOf(action.payload.tagId) >= 0
      if (
        action.payload.tagId == initState.boardDetails.tagId ||
        mirrorTagIdsExists
      ) {
        let stateChanged: boolean = false
        let subAIS = action.payload.subActionItems
        finalColumns = initState.boardDetails.columns.map((col: any) => {
          col.data = col.data.map(
            (item: {
              id: string
              state: string
              columnId: string
              board_column: any
              parent: string
            }) => {
              if (item.id == action.payload.id) {
                // sourceCol = action.payload.board_column == 0 ? col : '';
                sourceCol = col
                item = action.payload
                item.columnId =
                  initState.boardDetails.boardType ==
                  BoardConst.WS_BOARD_TYPE_PROGRESS
                    ? item.state
                    : item.board_column
                if (initState.boardDetails.viewAiPane) {
                  if (
                    initState.boardDetails.viewAiPane.id == action.payload.id
                  ) {
                    viewAiData = item
                  } else if (
                    initState.boardDetails.viewAiPane.parent ==
                    action.payload.id
                  ) {
                    let viewAI = action.payload.subActionItems.find(
                      (subAi: any) =>
                        subAi.id == initState.boardDetails.viewAiPane.id
                    )
                    viewAiData = viewAI
                  } else {
                    viewAiData = initState.boardDetails.viewAiPane
                  }
                }
              }
              // when subais in Ais are updated
              let sub = subAIS.find((subAi: any) => subAi.id == item.id)
              if (sub) {
                subAIS = subAIS.filter((sbAi: any) => sub.id != sbAi.id)
                // when subais state is updated
                if (item.state != sub.state) {
                  updatedSubAis.push(item.id)
                }
                item = sub
              }

              if (item.parent == action.payload.id) {
                parentAisData.push(item)
              }
              return item
            }
          )
          return col
        })
        destinationCol =
          action.payload.board_column == 0
            ? finalColumns.find(
                (column: any) => column.id == action.payload.state
              )
            : finalColumns.find(
                (column: any) =>
                  column.id === action.payload.board_column ||
                  column.id === sourceCol.id
              )

        if (
          sourceCol.id != destinationCol.id &&
          (mirrorTagIdsExists === true ||
            initState.boardDetails.boardType ==
              BoardConst.WS_BOARD_TYPE_PROGRESS)
        ) {
          stateChanged = true
          sourceCol.data = sourceCol.data.filter(
            (item: { id: string }) => item.id != action.payload.id
          )
          destinationCol.data.unshift(action.payload)
        }

        if (mirrorTagIdsExists) {
          sourceCol.id = action.payload.board_column
        }

        finalColumns = finalColumns.map((column: any) => {
          if (stateChanged) {
            if (column.id == sourceCol.id) {
              column = sourceCol
            }
            if (column.id == destinationCol.id) {
              column = destinationCol
            }
          }
          // removing the state updated subais from columns
          updatedSubAis &&
            updatedSubAis.forEach((sAI: any) => {
              let subData = column.data.find((d: any) => sAI == d.id)
              subData && updatedSubAisData.push(subData)
              column.data = subData
                ? column.data.filter((d: any) => d.id != subData.id)
                : column.data
            })
          //WW-11888
          let deletedSubs = parentAisData.filter((obj: any) => {
            return !action.payload.subActionItems.some((obj2: any) => {
              return obj.id == obj2.id
            })
          })
          column.data = column.data.filter((d: any) => {
            let delSub = deletedSubs.find((ds: any) => ds.id == d.id)
            if (delSub) {
              return (
                d.id !== delSub.id
              )
            }
            return d
          })
          return column
        })

        // adding subais to columns as per new state
        finalColumns.map((column: any) => {
          let colSpecificData = updatedSubAisData.filter(
            (upd: any) => upd.state == column.id
          )
          colSpecificData &&
            colSpecificData.forEach((c: any) => {
              column.data.unshift(c)
            })

          // when new ais are added in ai popup
          if (subAIS) {
            subAIS &&
              subAIS.forEach((subAi: any) => {
                if (column.id === subAi.board_column ||
                    (subAi.state === column.id && subAi.tagId === action.payload.tagId)
                ) {
                  column.data.push(subAi);
                }
              })
          }
          return column
        })

        return {
          ...state,
          boardDetails: {
            ...state.boardDetails,
            columns: finalColumns,
            viewAiPane: viewAiData,
          },
        }
      } else {
        finalColumns = initState.boardDetails.columns.map((col: any) => {
          col.data = col.data.filter((item: { id: string; parent: string }) => {
            if (item.id != action.payload.id) {
              return item
            }
          })
          return col
        })
        viewAiData =
          initState.boardDetails.viewAiPane &&
          initState.boardDetails.viewAiPane.id == action.payload.id
            ? ''
            : initState.boardDetails.viewAiPane
        return {
          ...state,
          boardDetails: {
            ...state.boardDetails,
            columns: finalColumns,
            viewAiPane: viewAiData,
          },
        }
      }
    case CardAction.UPDATE_AI_TYPE:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map(
            ({ data, ...restColumn }) => ({
              data: data?.map(
                ({ id, type, ...restData }) => ({
                  id,
                  type: id === action.id ? action.aiType : type,
                  ...restData,
                })
              ),
              ...restColumn,
            })
          ),
        }
      };

    /** SidePanel Actions */
    case SidePanelAction.CLOSE_SIDE_PANEL:
      const viewAiPane: any = ''
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiPane,
        },
      }
    case SidePanelAction.UPDATE_COUNT:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      itemData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      const { countType, count } = action
      if (typeof itemData[countType] !== 'undefined') {
        if (countType == 'subCount') {
          itemData[countType] = Object.assign({}, itemData[countType], count)
        } else {
          itemData[countType] = count
        }
      }

      viewAiData =
        initState.boardDetails.viewAiPane &&
        initState.boardDetails.viewAiPane.id == itemData.id
          ? itemData
          : initState.boardDetails.viewAiPane
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map((c: any) => {
            if (c.id == action.columnId) {
              c.data = c.data.map((d: any) => {
                if (d.id == action.aiId && itemData && itemData.id == d.id) {
                  d = { ...d, ...itemData }
                }
                return d
              })
            }
            return c
          }),
          viewAiPane: viewAiData,
        },
      }
    case SidePanelAction.BOARD_AI_PARENT_UPDATE:
      let parentColData: any = initState.boardDetails.columns.find((col) => {
        return col.data.find((d: { id: any }) => d.id == action.parentId)
      })
      let childColData: any = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      let childSubCount: any

      let parentAiName = ''
      const findParentObj: any = parentColData.data.find(
        (item: { id: any }) => item.id == action.parentId
      )
      if (action.parentId) {
        if (findParentObj) {
          parentAiName = findParentObj.description
        }
      }

      childColData.data.map(
        (item: {
          parent: string
          parentAiName: string
          id: string
          subCount: any
          stateText: string
        }) => {
          if (item.id == action.id) {
            item.parent = action.parentId
            item.parentAiName = parentAiName
            childSubCount = item.subCount
            childSubCount.doneStatusCount = item.stateText == 'Done' ? 1 : 0
            item.subCount = {
              doneCount: null,
              totalCount: '0',
            }
            viewAiData =
              initState.boardDetails.viewAiPane &&
              initState.boardDetails.viewAiPane.id == item.id
                ? item
                : initState.boardDetails.viewAiPane
          }
        }
      )

      parentColData.data.map((item: { id: any; subCount: any }) => {
        if (item.id == action.parentId) {
          item.subCount = {
            doneCount: String(
              (Number(item.subCount.doneCount) || 0) +
                Number(childSubCount.doneCount) +
                childSubCount.doneStatusCount
            ),
            totalCount: String(
              (Number(item.subCount.totalCount) || 0) +
                Number(childSubCount.totalCount) +
                1
            ),
          }
        }
      })

      initState.boardDetails.columns.map((column) => {
        column.data.map((item: { parent: string; parentAiName: string }) => {
          if (item.parent == action.id) {
            item.parent = action.parentId ? action.parentId : null
            item.parentAiName = parentAiName
          }
        })
      })

      finalColumns = initState.boardDetails.columns.map((column) => {
        column.data.map((item: { id: string }) => {
          if (item.id == action.id) {
            return childColData
          } else if (item.id == action.parentId) {
            return parentColData
          }
          return item
        })
        return column
      })
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: finalColumns,
          viewAiPane: viewAiData,
        },
      }
    case SidePanelAction.BOARD_SUB_TO_AI_PARENT_UPDATE:
      finalColumns = initState.boardDetails.columns.map((column: any) => {
        column.data = column.data.map(
          (item: {
            parent: string
            parentAiName: string
            parentAiState: string
            id: string
            subCount: any
          }) => {
            if (item.id == action.oldParentId) {
              item.subCount = {
                doneCount: String(
                  (Number(item.subCount.doneCount) || 0) - action.stateVal
                ),
                totalCount: String((Number(item.subCount.totalCount) || 0) - 1),
              }
            }
            if (item.id == action.id) {
              item.parent = ''
              item.parentAiName = ''
              item.parentAiState = ''
            }

            if (initState.boardDetails.viewAiPane.id == item.id) {
              viewAiData = item
            }
            return item
          }
        )
        return column
      })
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: finalColumns,
          viewAiPane: viewAiData,
        },
      }
    case SidePanelAction.BOARD_AI_DELETE:
      finalColumns = initState.boardDetails.columns.map((column: any) => {
        column.data = column.data.filter(
          (item: {
            parent: string
            id: string
            stateText: string
            subCount: any
          }) => {
            if (
              item.id &&
              item.id != action.aiId &&
              item.parent != action.aiId
            ) {
              if (item.id == action.parentId) {
                item.subCount = {
                  doneCount: String(
                    (Number(item.subCount.doneCount) || 0) -
                      (action.state == '0' ? 1 : 0)
                  ),
                  totalCount: String(
                    (Number(item.subCount.totalCount) || 0) - 1
                  ),
                }
              }
              if (initState.boardDetails.viewAiPane.id == action.aiId) {
                viewAiData = ''
              } else {
                viewAiData = initState.boardDetails.viewAiPane
              }
              return item
            }
          }
        )
        return column
      })

      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: finalColumns,
          viewAiPane: viewAiData,
        },
      }
    case SidePanelAction.BOARD_AI_DESC_CHANGE:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      viewAiData.description = action.description
      viewAiData =
        initState.boardDetails.viewAiPane &&
        initState.boardDetails.viewAiPane.id == viewAiData.id
          ? viewAiData
          : initState.boardDetails.viewAiPane
      if (
        viewAiData.state == 1 &&
        viewAiData.due_date &&
        viewAiData.start_date
      ) {
        boardTimeline = updateTimleineTask(initState, viewAiData)
      } else {
        boardTimeline = initState.boardTimeline
      }
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
        boardTimeline: boardTimeline,
      }
    case SidePanelAction.BOARD_AI_START_DATE:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      let { startDateText, startDateTextFormatted, start_date } = action
      viewAiData.startDateText = startDateText
      viewAiData.startDateTextFormatted = startDateTextFormatted
      if (start_date != '0' && start_date != null) {
        if (!isNaN(start_date)) {
          start_date = parseInt(start_date) + moment().utcOffset() * 60
        }
      }
      viewAiData.start_date = start_date
      viewAiData =
        initState.boardDetails.viewAiPane &&
        initState.boardDetails.viewAiPane.id == viewAiData.id
          ? viewAiData
          : initState.boardDetails.viewAiPane
      if (viewAiData.state == 1) {
        boardTimeline = updateTimleineTask(initState, viewAiData)
      } else {
        boardTimeline = initState.boardTimeline
      }
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
        boardTimeline: boardTimeline,
      }
    case SidePanelAction.BOARD_AI_END_DATE:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      let { dueDateText, dueDateTextFormatted, due_red, due_date } = action
      viewAiData.dueDateText = dueDateText
      viewAiData.dueDateTextFormatted = dueDateTextFormatted
      viewAiData.due_red = due_red
      if (due_date != '0' && due_date != null) {
        if (!isNaN(due_date)) {
          due_date = parseInt(due_date) + moment().utcOffset() * 60
        }
      }
      viewAiData.due_date = due_date
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane:
            initState.boardDetails.viewAiPane &&
            initState.boardDetails.viewAiPane.id == viewAiData.id
              ? viewAiData
              : state.boardDetails.viewAiPane,
        },
        boardTimeline:
          viewAiData.state == '1'
            ? updateTimleineTask(state, viewAiData)
            : state.boardTimeline,
      }
    case SidePanelAction.BOARD_AI_OWNER_CHANGE:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      const oldOwner = viewAiData.owner
      const newOwner = action.owner
      viewAiData.ownerImage = action.ownerImg
      viewAiData.owner_lastname = action.last_name
      viewAiData.owner_firstname = action.first_name
      viewAiData.owner = newOwner
      viewAiData =
        initState.boardDetails.viewAiPane &&
        initState.boardDetails.viewAiPane.id == viewAiData.id
          ? viewAiData
          : initState.boardDetails.viewAiPane
      // to do update timeline view
      if (
        viewAiData.state == 1 &&
        viewAiData.due_date &&
        viewAiData.start_date
      ) {
        boardTimeline = updateTimleineTask(initState, viewAiData, oldOwner)
      } else {
        boardTimeline = initState.boardTimeline
      }
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
        boardTimeline: boardTimeline,
      }

    case SidePanelAction.BOARD_AI_STATE:
      const { boardType } = initState.boardDetails
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: string }) => item.id == action.aiId
      )
      const oldState = viewAiData.state
      const newState: string = action.stateId
      let stateText: string
      if (oldState == newState) return state
      if (viewAiData) {
        viewAiData.state = action.stateId
      }
      if (boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) {
        destinationCol = initState.boardDetails.columns.find(
          (col) => col.id == action.stateId
        )
        sourceCol = colData.data.filter(
          (item: { id: string }) => item.id != action.aiId
        )
        destinationCol.data.unshift(viewAiData)
      }
      finalColumns = initState.boardDetails.columns.map((column) => {
        if (boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) {
          if (column.id == oldState) {
            column.data = sourceCol
          } else if (column.id == newState) {
            column.data = destinationCol.data
          }
        } else {
          if (column.id == action.columnId) {
            column.data = column.data.map((d: any) => {
              if (d.id == action.aiId) {
                if (initState.boardDetails.status_values) {
                  Object.keys(initState.boardDetails.status_values).forEach(
                    (status) => {
                      if (
                        initState.boardDetails.status_values[status].id ==
                        action.stateId
                      ) {
                        stateText =
                          initState.boardDetails.status_values[status].title
                      }
                    }
                  )
                }
                d = { ...d, state: action.stateId, stateText: stateText }
              }
              return d
            })
          }
        }
        if (newState == '0' || oldState == '0') {
          let parentId = viewAiData.parent
          column.data.map((par) => {
            if (par.id == parentId) {
              par.subCount.doneCount =
                newState == '0'
                  ? String((Number(par.subCount.doneCount) || 0) + 1)
                  : String(Number(par.subCount.doneCount) - 1)
            }
          })
        }
        return column
      })

      viewAiData.state = newState
      if (boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) {
        viewAiData.columnId = newState
      }
      if (initState.boardDetails.status_values) {
        const findState: any = initState.boardDetails.status_values.find(
          (item) => item.id === newState
        )
        if (findState) {
          viewAiData.stateText = findState.title
        }
      }
      if (oldState != 1 && newState == '1') {
        boardTimeline = updateTimleineTask(initState, viewAiData)
      }
      if (oldState == 1 && newState != '1') {
        boardTimeline = removeTimelineTask(initState, viewAiData.id)
      }
      viewAiData =
        initState.boardDetails.viewAiPane &&
        initState.boardDetails.viewAiPane.id == viewAiData.id
          ? viewAiData
          : initState.boardDetails.viewAiPane
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: finalColumns,
          viewAiPane: viewAiData,
        },
        boardTimeline:
          boardTimeline && Object.keys(boardTimeline).length
            ? boardTimeline
            : initState.boardTimeline,
      }
    case SidePanelAction.BOARD_AI_RAG:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      viewAiData.rag = action.ragId
      if (initState.boardDetails.rag_values) {
        const findRag: any = initState.boardDetails.rag_values.find(
          (item) => item.id === action.ragId
        )
        if (findRag) {
          viewAiData.ragText = findRag.title
        }
      }
      viewAiData =
        initState.boardDetails.viewAiPane &&
        initState.boardDetails.viewAiPane.id == viewAiData.id
          ? viewAiData
          : initState.boardDetails.viewAiPane
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
      }
    case SidePanelAction.BOARD_AI_EFFORT:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      viewAiData.effort = action.effortId
      if (initState.boardDetails.effort_values) {
        const findEffort: any = initState.boardDetails.effort_values.find(
          (item) => item.id == action.effortId
        )
        if (findEffort) {
          viewAiData.effortText = findEffort.title
        }
      }
      viewAiData =
        initState.boardDetails.viewAiPane &&
        initState.boardDetails.viewAiPane.id == viewAiData.id
          ? viewAiData
          : initState.boardDetails.viewAiPane
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
      }
    case SidePanelAction.BOARD_AI_PRIORITY:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      viewAiData.priority = action.priorityId
      if (initState.boardDetails.priority_values) {
        const findPriority: any = initState.boardDetails.priority_values.find(
          (item) => item.id == action.priorityId
        )
        if (findPriority) {
          viewAiData.priorityText = findPriority.title
        }
      }
      viewAiData =
        initState.boardDetails.viewAiPane &&
        initState.boardDetails.viewAiPane.id == viewAiData.id
          ? viewAiData
          : initState.boardDetails.viewAiPane
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
      }
    case SidePanelAction.BOARD_REMOVE_TAG:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      viewAiData.aiTags = viewAiData.aiTags.filter(
        (ta: { id: string }) => ta.id != action.tagId
      )
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
      }
    case SidePanelAction.BOARD_ADD_TAG:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      viewAiData.aiTags.push(action.payload)
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
      }
    case SidePanelAction.BOARD_AI_NOTES_CHANGE:
      colData = initState.boardDetails.columns.find(
        (col) => col.id == action.columnId
      )
      viewAiData = colData.data.find(
        (item: { id: any }) => item.id == action.aiId
      )
      viewAiData.note = action.notes
      viewAiData =
        initState.boardDetails.viewAiPane &&
        initState.boardDetails.viewAiPane.id == viewAiData.id
          ? viewAiData
          : initState.boardDetails.viewAiPane
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          viewAiPane: viewAiData,
        },
      }

    /** Filter Actions */
    case FilterAction.FILTER_ATTR_CHANGE:
      const filters = state.boardFilters
      if (
        action.name == 'status'
        || action.name == 'rating'
        || action.name == 'priority'
        || action.name == 'issueTypes'
      ) {
        const nameValue =
          typeof filters[action.name] !== 'undefined'
            ? filters[action.name]
            : []
        filters[action.name] = [...new Set([...nameValue, action.value])]
        if (action.isChecked) {
          filters[action.name] = filters[action.name].filter(
            (v: any) => v != action.value
          )
        }
      } else if (action.name == 'assignee') {
        filters['selected_assignee'] = action.value ? [action.value] : []
        filters[action.name] = action.value ? action.value.id : ''
      } else if (action.name == 'tags') {
        filters['selected_tag'] = action.value
        filters[action.name] = Array.isArray(action.value)
          ? action.value.map((t: any) => t.tagId)
          : []
      } else {
        filters[action.name] = action.value
      }
      return {
        ...state,
        boardFilters: { ...filters },
      }
    case FilterAction.FILTER_ATTR_BULK_APPLY:
      return {
        ...state,
        boardFilters: {
          ...state.boardFilters,
          ...action.payload,
        },
      }
    case CardAction.TIMELINE_MEMBER_HIGHLIGHTED:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          memberHighlightedId: action.memberId,
        },
      }
    case CardAction.TIMELINE_DATE_CHANGED:
      const task = action.value
      let ai: any = undefined
      const startDate = moment(task._start)
      const dueDate = moment(task._end)
      const startTimestamp = startDate.format('X')
      const endTimestamp = dueDate.format('X')
      const _columns = state.boardDetails.columns.map((c: any) => {
        if (c.data) {
          c.data.map((d: any) => {
            if (d.id == task.id) {
              d.start_date = startTimestamp
              d.due_date = endTimestamp
              d.startDateText = startDate.format('MMM DD, YYYY')
              d.dueDateText = dueDate.format('MMM DD, YYYY')
              ai = d
            }
          })
        }
        return c
      })
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: _columns,
          viewAiPane:
            state.boardDetails.viewAiPane &&
            ai &&
            state.boardDetails.viewAiPane.id == ai.id
              ? ai
              : state.boardDetails.viewAiPane,
        },
        boardTimeline:
          ai && Object.keys(ai).length
            ? updateTimleineTask(state, ai)
            : state.boardTimeline,
      }
    case MenuAction.GET_MENU_PERMISSION:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          ...action.permissions,
        },
      }
    case MenuAction.UPDATE_MENU_PERMISSION:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          userPermission: {
            ...state.boardDetails.userPermission,
            ...action.permissions,
          },
        },
      }
    case MenuAction.CHANGE_MENU_BOARD_THEME:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          boardSettings: {
            ...state.boardDetails.boardSettings,
            theme: action.theme,
          },
        },
      }
    case MenuAction.CHANGE_MENU_BOARD_COUMN_HEADER:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map((c: any) => {
            if (c.id == action.columnId) {
              c.color = action.color
            }
            return c
          }),
        },
      }
    case MenuAction.CHANGE_MENU_BOARD_STATE:
      let resetStates: any = {}
      if (action.theme && Object.keys(action.theme).length) {
        resetStates.boardSettings = {
          ...state.boardDetails.boardSettings,
          theme: action.theme,
        }
      }
      if (Array.isArray(action.columns) && action.columns.length) {
        resetStates.columns = state.boardDetails.columns.map((c: any) => {
          let findColumn = action.columns.find((v: any) => v.id == c.id)
          if (findColumn) {
            c.color = findColumn.color
            if (
              action.actionType == 'update' &&
              action.boardType == BoardConst.WS_BOARD_TYPE_PROGRESS
            ) {
              c.title = findColumn['title'] || c.title
              c.visible = findColumn['visible'] || c.visible
            }
          }
          return c
        })
        if (action.actionType == 'update') {
          resetStates.appyToAllWs = action.appyToAllWs
        }
      }
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          ...resetStates,
        },
      }
    case MenuAction.BOARD_UPDATE_SHARED_MEMBERS:
      let newSharedMembers = initState.boardDetails.board.sharedMembers
      let newShareType = initState.boardDetails.board.share_type

      if (typeof initState.boardDetails.board.sharedMembers !== 'undefined') {
        if (typeof action.data.members !== 'undefined') {
          newSharedMembers = action.data.members
        }
        if (typeof action.data.share_type !== 'undefined') {
          newShareType = action.data.share_type
        }
      }
      let board = {
        ...state.boardDetails.board,
        sharedMembers: newSharedMembers,
        share_type: newShareType,
      }
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          board,
        },
      }

    /** Board Header Actions */
    case BorderAction.BRD_HEADER_FAV_ADD:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          isFavorites: 1,
        },
      }
    case BorderAction.BRD_HEADER_FAV_DEL:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          isFavorites: 0,
        },
      }
    case BorderAction.BRD_UPDATE_BOARD_DATA:
      if (typeof initState.boardDetails.board !== 'undefined') {
        var newBoard = Object.assign(
          {},
          initState.boardDetails.board,
          action.payload
        )
      }
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          board: newBoard,
        },
      }
    case CardAction.ADD_CARD:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map((c: any) => {
            if (c.id == action.columnId) {
              c.data = uniqueArrayObject([...c.data, ...action.items], 'id')
            }
            return c
          }),
        },
      }
    case CardAction.DELETE_CARD:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map((column: any) => {
            const idx = column.data.findIndex(item => item.id === action.id);
            if (idx !== -1) {
              return {
                ...column,
                data: column.data.filter(item => item.id !== action.id)
              }
            }
            return column;
          }),
        },
      }
    case CardAction.UPDATE_CARD:
      return {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map((c: any) => {
            // update card to workstream board multiple columns
            if (action.cardType == BoardConst.BOARD_DATATYPE_WORKSTREAMS) {
              c.data = c.data.map((d: any) => {
                if (d.id == action.id) {
                  d = Object.assign({}, d, action.item)
                }
                return d
              })
            } else {
              if (c.id == action.columnId) {
                c.data = c.data.map((d: any) => {
                  if (d.id == action.id) {
                    d = Object.assign({}, d, action.item)
                  }
                  return d
                })
              }
            }
            return c
          }),
        },
      }
    case CardAction.BOARD_UPDATE_RELATIONSHIP_COUNTS:
      const { counts, requestedIds } = action.payload
      let updated = false
      const updatedState = {
        ...state,
        boardDetails: {
          ...state.boardDetails,
          columns: state.boardDetails.columns.map((c: any) => {
            c.data = c.data.map((ai: any) => {
              const countItem = counts.find(
                (count) => String(count.actionItemId) === ai.id
              )
              if (countItem) {
                if (ai.relationshipsCount !== countItem.relationshipsCount) {
                  updated = true
                  return {
                    ...ai,
                    relationshipsCount: countItem.relationshipsCount,
                  }
                }
              } else if (requestedIds.includes(ai.id)) {
                updated = true
                return {
                  ...ai,
                  relationshipsCount: 0,
                }
              }
              return ai
            })
            return c
          }),
          viewAiPane:
            state.boardDetails.viewAiPane &&
            requestedIds.includes(state.boardDetails.viewAiPane.id)
              ? {
                  ...state.boardDetails.viewAiPane,
                  relationshipsCount:
                    counts.find(
                      (count) =>
                        String(count.actionItemId) ===
                        state.boardDetails.viewAiPane.id
                    )?.relationshipsCount ?? 0,
                }
              : state.boardDetails.viewAiPane,
        },
        boardTimeline:
          boardTimeline && Object.keys(boardTimeline).length
            ? boardTimeline
            : state.boardTimeline,
      }
      return updated ? updatedState : state
    case ColumnAction.BOARD_MERGE_AUTOMATION:
      return {
        ...state,
        boardDetails: action.boardDetails,
        boardTimeline: action.boardTimeline
          ? action.boardTimeline
          : state.boardTimeline,
      }
    case ColumnAction.BOARD_UPDATE_TIMELINE:
      return {
        ...state,
        boardTimeline: action.boardTimeline,
      }
    case CardAction.BOARD_FREETEXT_UPDATE_IMG:
        let newEditUpdatedColumnImg: any = initState.boardDetails.columns.map(
          (item: any) => {
              item.data.map (
                (it: any) => {
                  if(it.id == action.payload.id){
                    it.description = action.payload.description
                    it.fus_status = 1
                  }
                }
              )
            return item
          }
        )
        return {
          ...state,
          boardDetails: {
            ...state.boardDetails,
            columns: newEditUpdatedColumnImg,
          },
        }
    default:
      return state
  }
}

export default BoardReducers
